import React from 'react';
import { Progress, Typography } from 'antd';
import { CheckCircleFilled, MinusCircleFilled } from '@ant-design/icons';
import styled from 'styled-components';

const { Text } = Typography;

const Wrapper = styled.div`
  margin-top: 6px;
`;

const BarRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
`;

const CheckItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: ${({ passed }) => (passed ? '#52c41a' : '#8c8c8c')};
  margin-top: 3px;
`;

const checks = [
  { label: 'At least 8 characters', test: v => v.length >= 8 },
  { label: 'Uppercase letter (A–Z)', test: v => /[A-Z]/.test(v) },
  { label: 'Lowercase letter (a–z)', test: v => /[a-z]/.test(v) },
  { label: 'Number (0–9)', test: v => /[0-9]/.test(v) },
  { label: 'Special character (!@#$...)', test: v => /[^A-Za-z0-9]/.test(v) },
];

const strengthConfig = [
  { label: 'Very Weak', color: '#ff4d4f', percent: 20 },
  { label: 'Weak', color: '#ff7a45', percent: 40 },
  { label: 'Fair', color: '#ffa940', percent: 60 },
  { label: 'Good', color: '#36cfc9', percent: 80 },
  { label: 'Strong', color: '#52c41a', percent: 100 },
];

const PasswordStrengthIndicator = ({ value = '' }) => {
  if (!value) return null;

  const passedCount = checks.filter(c => c.test(value)).length;
  const allPassed = passedCount === checks.length;
  const strength = strengthConfig[passedCount - 1] || strengthConfig[0];

  return (
    <Wrapper>
      {!allPassed && (
        <BarRow>
          <Progress
            percent={strength.percent}
            showInfo={false}
            strokeColor={strength.color}
            style={{ flex: 1, marginBottom: 0 }}
            size='small'
          />
          <Text style={{ fontSize: 12, color: strength.color, whiteSpace: 'nowrap' }}>
            {strength.label}
          </Text>
        </BarRow>
      )}
      {!allPassed && checks.map(({ label, test }) => (
        <CheckItem key={label} passed={test(value) ? 1 : 0}>
          {test(value)
            ? <CheckCircleFilled style={{ color: '#52c41a' }} />
            : <MinusCircleFilled style={{ color: '#d9d9d9' }} />
          }
          {label}
        </CheckItem>
      ))}
    </Wrapper>
  );
};

export default PasswordStrengthIndicator;
